import { SystemConfigurationFormData } from "@app/types/SystemConfiguration";

export const ALERT_REFRESH_TIME = 10000;
export enum GlobalEnum {
    // eslint-disable-next-line
    GLOBAL_EPT = "GLOBAL_EPT",
}

export const BULK_AUTO_ACTION_MODE = {
    autoProcess: "1",
    autoReject: "2",
};

export const FEATURE_CHECKBOXES: {
    key: keyof SystemConfigurationFormData;
    label: string;
}[] = [
    { key: "outOfQueue", label: "Out of Queue" },
    { key: "wastage", label: "Wastage" },
    { key: "bulk", label: "Bulk" },
    { key: "optimizeClubbing", label: "Optimize Clubbing" },
    { key: "globalEPT", label: "EPT" },
    { key: "consumeOverdue", label: "Consume Overdue" },
];
